













































































import { Vue, Component } from 'vue-property-decorator'
import HeaderBox from '@/components/HeaderBox.vue'
import cache from '@/common/cache';

interface SearchParams {
  export_time: string
  user_name: string
  start_date: string
  end_date: string
  page: number
  count: number
}

@Component({
  components: {
    HeaderBox
  }
})
export default class ExportRecord extends Vue {
  tableData: object[] = []

  loading: boolean = false

  searchParams: SearchParams = {
    export_time: '',
    user_name: '',
    start_date: '',
    end_date: '',
    page: 1,
    count: 10
  }
  totalNum: number = 0
  showFailPopover: boolean = false
  exception_msg = ''
  timer = null

  created () {
    this.getExportRecord();
  }

  async getExportRecord () {
    this.loading = true;
    const { code, data } = await this.$rest.dataCenter.getExportRecord(this.searchParams);
    this.loading = false;
    if (code !== 0) return;
    this.tableData = data.infos;
    this.totalNum = data.total_count;
    this.setTimeoutTask(data.infos)
  }

  setTimeoutTask (exportList) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.checkExportComplete(exportList);
    }, 1000);
  }

  checkExportComplete (exportList) {
    exportList.forEach(item => {
      // 进行中
      if (+item.status === 2) {
        this.getExportRecord();
      }
    });
  }

  setTime (value) {
    this.searchParams.start_date = value && value[0];
    this.searchParams.end_date = value && value[1];
  }

  handleLook (exception_msg) {
    this.exception_msg = exception_msg;
    this.showFailPopover = true;
  }

  handelSearch () {
    this.getExportRecord();
  }

  handleReset () {
    this.searchParams.user_name = '';
    this.searchParams.start_date = '';
    this.searchParams.end_date = '';
    this.searchParams.export_time = '';
    this.searchParams.page = 1;
    this.getExportRecord();
  }

  handleCurrentChange () {
    this.getExportRecord();
  }

  handleCloseFail () {
    this.showFailPopover = false;
    (this.$refs.popoverFail as any).showPopper = false;
  }

  handleDownload (id) {
    window.location.href = this.joinTokenToUrl(`/api/v1/data_center/inventory/export/${id}/file`);
  }

  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
